<template>
  <svg :viewBox="'0 0 ' + width + ' ' + height" :width="(width + 8) + 'px'" :height="height + 'px'" version="1.1"
       xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 62 (91390) - https://sketch.com -->
    <title>Group</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <circle cx="39" cy="140" id="path-1" r="39"></circle>
      <filter filterUnits="objectBoundingBox" height="106.0%" id="filter-2" width="106.0%" x="-1.7%" y="-1.7%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="131.030672" cy="157.290015" id="path-3" r="19.5"></circle>
      <filter filterUnits="objectBoundingBox" height="111.9%" id="filter-4" width="111.9%" x="-3.4%" y="-3.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="95.3667649" cy="161.040015" id="path-5" r="15.75"></circle>
      <filter filterUnits="objectBoundingBox" height="114.8%" id="filter-6" width="114.8%" x="-4.2%" y="-4.2%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>

      <polygon id="path-7"
               points="24 114 24 111.037628 56.1901182 106.588662 52.5874885 87.4645988 73.4924173 82.4342271 72.5730124 63.0169163 88.4101563 55 90 57.424613 75.4339068 64.8331474 76.2743028 84.3047377 56.1901182 89.2625532 60.2445771 109.076185"></polygon>
      <filter filterUnits="objectBoundingBox" height="108.1%" id="filter-8" width="107.3%" x="-2.0%" y="-2.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M142.674823,128.533081 L183.697804,157.820241 C188.852572,151.081377 192.308712,142.989835 193.350537,134.061629 C194.391456,125.133424 192.886246,116.500022 189.413346,108.820241 L142.674823,128.533081"
        id="path-9"></path>
      <filter filterUnits="objectBoundingBox" height="109.9%" id="filter-10" width="108.9%" x="-2.3%" y="-2.9%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="70.5" cy="64" id="path-11" r="19.5"></circle>
      <filter filterUnits="objectBoundingBox" height="111.9%" id="filter-12" width="111.9%" x="-3.4%" y="-3.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M69.2487231,98.7711692 L125.554776,140.012272 C132.629948,130.522852 137.37367,119.12864 138.803625,106.556269 C140.232337,93.9838975 138.166362,81.8266577 133.399637,71.012272 L69.2487231,98.7711692"
        id="path-13"></path>
      <filter filterUnits="objectBoundingBox" height="107.1%" id="filter-14" width="106.5%" x="-1.7%" y="-2.1%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M247.648738,95.2588972 L303.954791,136.5 C311.029962,127.01058 315.773684,115.616368 317.20364,103.043997 C318.632352,90.4716255 316.566377,78.3143857 311.799651,67.5 L247.648738,95.2588972"
        id="path-15"></path>
      <filter filterUnits="objectBoundingBox" height="107.1%" id="filter-16" width="106.5%" x="-1.7%" y="-2.1%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M25.4658303,82.9778699 L49.596996,100.311087 C52.6292122,96.3227801 54.662236,91.5339082 55.2750741,86.2498682 C55.8873792,80.9658281 55.0019614,75.8562636 52.959079,71.311087 L25.4658303,82.9778699"
        id="path-17"></path>
      <filter filterUnits="objectBoundingBox" height="116.8%" id="filter-18" width="115.0%" x="-4.0%" y="-4.9%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="305.5" cy="153" id="path-19" r="25.5"></circle>
      <filter filterUnits="objectBoundingBox" height="109.1%" id="filter-20" width="109.1%" x="-2.6%" y="-2.6%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="231.576374" cy="141.209985" id="path-21" r="19.5"></circle>
      <filter filterUnits="objectBoundingBox" height="111.9%" id="filter-22" width="111.9%" x="-3.4%" y="-3.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="197" cy="159.5" id="path-23" r="19.5"></circle>
      <filter filterUnits="objectBoundingBox" height="111.9%" id="filter-24" width="111.9%" x="-3.4%" y="-3.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <polygon id="path-25"
               points="232.732243 112.962774 232.732243 110.000402 264.922361 105.551436 261.319731 86.427373 282.22466 81.3970014 281.305255 61.9796905 297.142399 53.9627742 298.732243 56.3873872 284.166149 63.7959216 285.006545 83.267512 264.922361 88.2253275 268.97682 108.038959"></polygon>
      <filter filterUnits="objectBoundingBox" height="108.1%" id="filter-26" width="107.3%" x="-2.0%" y="-2.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <polygon id="path-27"
               points="83.6949507 73.9167893 83.6949507 70.9544169 115.885069 66.5054514 112.282439 47.3813881 133.187368 42.3510164 132.267963 22.9337056 148.105107 14.9167893 149.694951 17.3414023 135.128858 24.7499367 135.969253 44.221527 115.885069 49.1793425 119.939528 68.9929746"></polygon>
      <filter filterUnits="objectBoundingBox" height="108.1%" id="filter-28" width="107.3%" x="-2.0%" y="-2.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <polygon id="path-29"
               points="312.210768 116.193379 312.210768 113.231006 344.400886 108.782041 340.798257 89.6579775 361.703186 84.6276059 360.783781 65.210295 376.620925 57.1933788 378.210768 59.6179917 363.644675 67.0265262 364.485071 86.4981165 344.400886 91.455932 348.455345 111.269564"></polygon>
      <filter filterUnits="objectBoundingBox" height="108.1%" id="filter-30" width="107.3%" x="-2.0%" y="-2.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M231,160.71284 L272.022982,190 C277.177749,183.261137 280.63389,175.169594 281.675714,166.241389 C282.716633,157.313183 281.211423,148.679781 277.738523,141 L231,160.71284"
        id="path-31"></path>
      <filter filterUnits="objectBoundingBox" height="109.9%" id="filter-32" width="108.9%" x="-2.3%" y="-2.9%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M319.668441,163.42715 L355.060817,188.694503 C359.508067,182.880582 362.489836,175.899644 363.388665,168.196878 C364.286712,160.494112 362.9881,153.045687 359.991872,146.419993 L319.668441,163.42715"
        id="path-33"></path>
      <filter filterUnits="objectBoundingBox" height="111.5%" id="filter-34" width="110.3%" x="-2.7%" y="-3.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="468.5" cy="82.5" id="path-35" r="11.5"></circle>
      <filter filterUnits="objectBoundingBox" height="120.2%" id="filter-36" width="120.2%" x="-5.8%" y="-5.8%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="544.5" cy="89" id="path-37" r="9"></circle>
      <filter filterUnits="objectBoundingBox" height="125.8%" id="filter-38" width="125.8%" x="-7.4%" y="-7.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="142.418978" cy="128.5" id="path-39" r="11.5"></circle>
      <filter filterUnits="objectBoundingBox" height="120.2%" id="filter-40" width="120.2%" x="-5.8%" y="-5.8%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="381" cy="110" id="path-41" r="10"></circle>
      <filter filterUnits="objectBoundingBox" height="123.2%" id="filter-42" width="123.2%" x="-6.6%" y="-6.6%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="444.5" cy="139.5" id="path-43" r="7.5"></circle>
      <filter filterUnits="objectBoundingBox" height="131.0%" id="filter-44" width="131.0%" x="-8.8%" y="-8.8%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="469" cy="147" id="path-45" r="9"></circle>
      <filter filterUnits="objectBoundingBox" height="125.8%" id="filter-46" width="125.8%" x="-7.4%" y="-7.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="106.194951" cy="38.5" id="path-47" r="11.5"></circle>
      <filter filterUnits="objectBoundingBox" height="120.2%" id="filter-48" width="120.2%" x="-5.8%" y="-5.8%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="334.710768" cy="80.7765895" id="path-49" r="11.5"></circle>
      <filter filterUnits="objectBoundingBox" height="120.2%" id="filter-50" width="120.2%" x="-5.8%" y="-5.8%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M204.039298,109.234561 L235.007628,131.917168 C238.898972,126.697987 241.508019,120.43117 242.294494,113.516366 C243.080286,106.601562 241.944,99.9150801 239.322301,93.967168 L204.039298,109.234561"
        id="path-51"></path>
      <filter filterUnits="objectBoundingBox" height="112.9%" id="filter-52" width="111.7%" x="-3.1%" y="-3.8%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M124.17237,77.4064148 L155.542885,100.383601 C159.484766,95.0966381 162.127697,88.748434 162.924386,81.7438273 C163.720383,74.7392206 162.56934,67.9659013 159.913593,61.9407435 L124.17237,77.4064148"
        id="path-53"></path>
      <filter filterUnits="objectBoundingBox" height="112.7%" id="filter-54" width="111.6%" x="-3.1%" y="-3.7%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M343,130.465671 L374.370515,153.442857 C378.312397,148.155895 380.955327,141.807691 381.752017,134.803084 C382.548014,127.798477 381.39697,121.025158 378.741223,115 L343,130.465671"
        id="path-55"></path>
      <filter filterUnits="objectBoundingBox" height="112.7%" id="filter-56" width="111.6%" x="-3.1%" y="-3.7%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M152,85.9312629 L198.513696,120 C204.358403,112.160914 208.27713,102.748304 209.458397,92.3624319 C210.638638,81.9765602 208.931963,71.933623 204.994233,63 L152,85.9312629"
        id="path-57"></path>
      <filter filterUnits="objectBoundingBox" height="108.6%" id="filter-58" width="107.8%" x="-2.1%" y="-2.5%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M381,124.931263 L427.513696,159 C433.358403,151.160914 437.27713,141.748304 438.458397,131.362432 C439.638638,120.97656 437.931963,110.933623 433.994233,102 L381,124.931263"
        id="path-59"></path>
      <filter filterUnits="objectBoundingBox" height="108.6%" id="filter-60" width="107.8%" x="-2.1%" y="-2.5%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M154.174823,158.876768 L178.305988,176.209985 C181.338205,172.221678 183.371228,167.432806 183.984067,162.148766 C184.596372,156.864726 183.710954,151.755162 181.668071,147.209985 L154.174823,158.876768"
        id="path-61"></path>
      <filter filterUnits="objectBoundingBox" height="116.8%" id="filter-62" width="115.0%" x="-4.0%" y="-4.9%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="312.335806" cy="112" id="path-63" r="39"></circle>
      <filter filterUnits="objectBoundingBox" height="106.0%" id="filter-64" width="106.0%" x="-1.7%" y="-1.7%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <polygon id="path-65"
               points="329.335806 77 329.335806 74.0376276 361.525924 69.5886621 357.923294 50.4645988 378.828223 45.4342271 377.908818 26.0169163 393.745962 18 395.335806 20.424613 380.769713 27.8331474 381.610109 47.3047377 361.525924 52.2625532 365.580383 72.0761853"></polygon>
      <filter filterUnits="objectBoundingBox" height="108.1%" id="filter-66" width="107.3%" x="-2.0%" y="-2.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <polygon id="path-67"
               points="41.9341468 127.680857 41.9341468 124.718485 64.124265 120.269519 60.5216353 101.145456 81.426564 96.1150841 80.5071592 76.6977732 94.344303 69.680857 95.9341468 72.10547 83.3680536 78.5140044 84.2084495 97.9855947 64.124265 102.94341 68.1787238 122.757042"></polygon>
      <filter filterUnits="objectBoundingBox" height="108.3%" id="filter-68" width="108.9%" x="-2.5%" y="-2.5%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="333.835806" cy="44.5" id="path-69" r="24.5"></circle>
      <filter filterUnits="objectBoundingBox" height="109.5%" id="filter-70" width="109.5%" x="-2.7%" y="-2.7%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="24.5" cy="60.5" id="path-71" r="24.5"></circle>
      <filter filterUnits="objectBoundingBox" height="109.5%" id="filter-72" width="109.5%" x="-2.7%" y="-2.7%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M362.027874,102.871889 L374.907428,76.0974489 C370.453174,73.803861 365.384025,72.6333024 360.073843,72.9473386 C354.763754,73.2618996 349.885566,75.0211325 345.764184,77.8222406 L362.027874,102.871889"
        id="path-73"></path>
      <filter filterUnits="objectBoundingBox" height="116.6%" id="filter-74" width="116.7%" x="-5.0%" y="-4.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M64.6262153,153.552746 L77.505769,126.778306 C73.0515146,124.484718 67.9823655,123.314159 62.6721837,123.628196 C57.3620945,123.942757 52.4839069,125.701989 48.3625245,128.503098 L64.6262153,153.552746"
        id="path-75"></path>
      <filter filterUnits="objectBoundingBox" height="116.6%" id="filter-76" width="116.7%" x="-5.0%" y="-4.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M266.719268,130.318196 L276,111.877735 C272.790359,110.298064 269.137639,109.49186 265.311235,109.708148 C261.484898,109.924796 257.96978,111.136439 255,113.065657 L266.719268,130.318196"
        id="path-77"></path>
      <filter filterUnits="objectBoundingBox" height="124.0%" id="filter-78" width="123.3%" x="-6.9%" y="-6.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="425.266012" cy="141.24997" id="path-79" r="9.25"></circle>
      <filter filterUnits="objectBoundingBox" height="125.1%" id="filter-80" width="125.1%" x="-7.2%" y="-7.2%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="407.25" cy="141.24997" id="path-81" r="9.25"></circle>
      <filter filterUnits="objectBoundingBox" height="125.1%" id="filter-82" width="125.1%" x="-7.2%" y="-7.2%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="416.5" cy="127" id="path-83" r="7.5"></circle>
      <filter filterUnits="objectBoundingBox" height="131.0%" id="filter-84" width="131.0%" x="-8.8%" y="-8.8%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <polygon id="path-85"
               points="379.835806 129 379.835806 126.037628 412.025924 121.588662 408.423294 102.464599 429.328223 97.4342271 428.408818 78.0169163 444.245962 70 445.835806 72.424613 431.269713 79.8331474 432.110109 99.3047377 412.025924 104.262553 416.080383 124.076185"></polygon>
      <filter filterUnits="objectBoundingBox" height="108.1%" id="filter-86" width="107.3%" x="-2.0%" y="-2.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <polygon id="path-87"
               points="195 75 195 72.0376276 227.190118 67.5886621 223.587489 48.4645988 244.492417 43.4342271 243.573012 24.0169163 259.410156 16 261 18.424613 246.433907 25.8331474 247.274303 45.3047377 227.190118 50.2625532 231.244577 70.0761853"></polygon>
      <filter filterUnits="objectBoundingBox" height="108.1%" id="filter-88" width="107.3%" x="-2.0%" y="-2.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="425.266012" cy="101.634485" id="path-89" r="13.75"></circle>
      <filter filterUnits="objectBoundingBox" height="116.9%" id="filter-90" width="116.9%" x="-4.8%" y="-4.8%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M386.961518,13.3197027 L362.122297,39.0494097 C357.690614,34.9051135 354.269833,29.596309 352.422472,23.401277 C350.575741,17.2061347 350.536393,10.9098844 351.985111,5.04940969 L386.961518,13.3197027"
        id="path-91"></path>
      <filter filterUnits="objectBoundingBox" height="114.3%" id="filter-92" width="113.8%" x="-3.7%" y="-4.1%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M462.882783,110.649256 L444.306442,129.568158 C440.99215,126.520881 438.433874,122.617349 437.0523,118.062178 C435.671197,113.506926 435.641771,108.877331 436.725214,104.568158 L462.882783,110.649256"
        id="path-93"></path>
      <filter filterUnits="objectBoundingBox" height="119.4%" id="filter-94" width="118.4%" x="-4.9%" y="-5.6%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M83,68.270293 L58.1607791,94 C53.7290961,89.8557038 50.3083155,84.5468993 48.4609541,78.3518673 C46.6142227,72.156725 46.5748751,65.8604747 48.0235932,60 L83,68.270293"
        id="path-95"></path>
      <filter filterUnits="objectBoundingBox" height="114.3%" id="filter-96" width="113.8%" x="-3.7%" y="-4.1%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M443.079712,158.487404 L430.200159,131.712963 C434.654413,129.419376 439.723562,128.248817 445.033744,128.562853 C450.343833,128.877414 455.222021,130.636647 459.343403,133.437755 L443.079712,158.487404"
        id="path-97"></path>
      <filter filterUnits="objectBoundingBox" height="116.6%" id="filter-98" width="116.7%" x="-4.9%" y="-4.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M307.21536,80.9748082 L294.335806,54.2003676 C298.79006,51.9067797 303.859209,50.7362211 309.169391,51.0502573 C314.47948,51.3648183 319.357668,53.1240512 323.47905,55.9251593 L307.21536,80.9748082"
        id="path-99"></path>
      <filter filterUnits="objectBoundingBox" height="116.6%" id="filter-100" width="116.7%" x="-4.9%" y="-4.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="283" cy="68" id="path-101" r="9"></circle>
      <filter filterUnits="objectBoundingBox" height="125.8%" id="filter-102" width="125.8%" x="-7.4%" y="-7.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="269" cy="55" id="path-103" r="10"></circle>
      <filter filterUnits="objectBoundingBox" height="123.2%" id="filter-104" width="123.2%" x="-6.6%" y="-6.6%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M261.879554,97.9748082 L249,71.2003676 C253.454254,68.9067797 258.523403,67.7362211 263.833585,68.0502573 C269.143674,68.3648183 274.021862,70.1240512 278.143244,72.9251593 L261.879554,97.9748082"
        id="path-105"></path>
      <filter filterUnits="objectBoundingBox" height="116.6%" id="filter-106" width="116.7%" x="-4.9%" y="-4.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M279.349048,157.296689 L269.626377,137.08488 C272.988858,135.353469 276.815518,134.469824 280.824131,134.706887 C284.832675,134.944347 288.515179,136.272377 291.626377,138.386911 L279.349048,157.296689"
        id="path-107"></path>
      <filter filterUnits="objectBoundingBox" height="122.0%" id="filter-108" width="122.2%" x="-6.5%" y="-5.9%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M21.8795537,158.974808 L9,132.200368 C13.4542544,129.90678 18.5234034,128.736221 23.8335852,129.050257 C29.1436745,129.364818 34.0218621,131.124051 38.1432444,133.925159 L21.8795537,158.974808"
        id="path-109"></path>
      <filter filterUnits="objectBoundingBox" height="116.6%" id="filter-110" width="116.7%" x="-4.9%" y="-4.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M427.505937,43.300349 L374.505937,72.6352313 C379.366614,81.7345098 386.57664,89.6918607 395.925127,95.461948 C405.27407,101.231051 415.576637,104.081886 425.813659,104.300349 L427.505937,43.300349"
        id="path-111"></path>
      <filter filterUnits="objectBoundingBox" height="107.6%" id="filter-112" width="109.0%" x="-2.7%" y="-2.1%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="375.835806" cy="124.99997" id="path-113" r="25.5"></circle>
      <filter filterUnits="objectBoundingBox" height="109.1%" id="filter-114" width="109.1%" x="-2.6%" y="-2.6%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="73" cy="115" id="path-115" r="18"></circle>
      <filter filterUnits="objectBoundingBox" height="112.9%" id="filter-116" width="112.9%" x="-3.7%" y="-3.7%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <polygon id="path-117"
               points="74.0582562 59 74.0582562 56.0376276 106.248374 51.5886621 102.645745 32.4645988 123.550673 27.4342271 122.631269 8.01691626 138.468412 0 140.058256 2.42461298 125.492163 9.83314739 126.332559 29.3047377 106.248374 34.2625532 110.302833 54.0761853"></polygon>
      <filter filterUnits="objectBoundingBox" height="108.1%" id="filter-118" width="107.3%" x="-2.0%" y="-2.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <polygon id="path-119"
               points="12 102 12 99.0376276 44.1901182 94.5886621 40.5874885 75.4645988 61.4924173 70.4342271 60.5730124 51.0169163 76.4101563 43 78 45.424613 63.4339068 52.8331474 64.2743028 72.3047377 44.1901182 77.2625532 48.2445771 97.0761853"></polygon>
      <filter filterUnits="objectBoundingBox" height="108.1%" id="filter-120" width="107.3%" x="-2.0%" y="-2.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="86.0582562" cy="38" id="path-121" r="17"></circle>
      <filter filterUnits="objectBoundingBox" height="113.7%" id="filter-122" width="113.7%" x="-3.9%" y="-3.9%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M106.750325,84.8718895 L119.629878,58.0974489 C115.175624,55.803861 110.106475,54.6333024 104.796293,54.9473386 C99.4862039,55.2618996 94.6080163,57.0211325 90.486634,59.8222406 L106.750325,84.8718895"
        id="path-123"></path>
      <filter filterUnits="objectBoundingBox" height="116.6%" id="filter-124" width="116.7%" x="-5.0%" y="-4.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="192" cy="122.49997" id="path-125" r="10"></circle>
      <filter filterUnits="objectBoundingBox" height="123.2%" id="filter-126" width="123.2%" x="-6.6%" y="-6.6%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="13" cy="122.49997" id="path-127" r="10"></circle>
      <filter filterUnits="objectBoundingBox" height="123.2%" id="filter-128" width="123.2%" x="-6.6%" y="-6.6%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="60" cy="77" id="path-129" r="10"></circle>
      <filter filterUnits="objectBoundingBox" height="123.2%" id="filter-130" width="123.2%" x="-6.6%" y="-6.6%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="169" cy="119.49997" id="path-131" r="13"></circle>
      <filter filterUnits="objectBoundingBox" height="117.9%" id="filter-132" width="117.9%" x="-5.1%" y="-5.1%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <polygon id="path-133"
               points="124.558256 111 124.558256 108.037628 156.748374 103.588662 153.145745 84.4645988 174.050673 79.4342271 173.131269 60.0169163 188.968412 52 190.558256 54.424613 175.992163 61.8331474 176.832559 81.3047377 156.748374 86.2625532 160.802833 106.076185"></polygon>
      <filter filterUnits="objectBoundingBox" height="108.1%" id="filter-134" width="107.3%" x="-2.0%" y="-2.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="169.988462" cy="83.6344854" id="path-135" r="13.75"></circle>
      <filter filterUnits="objectBoundingBox" height="116.9%" id="filter-136" width="116.9%" x="-4.8%" y="-4.8%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="84.5" cy="84" id="path-137" r="15.5"></circle>
      <filter filterUnits="objectBoundingBox" height="115.0%" id="filter-138" width="115.0%" x="-4.3%" y="-4.3%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M73.7063391,41.0342973 L57.1468585,58.1874353 C54.1924032,55.4245712 51.9118828,51.8853682 50.6803085,47.7553468 C49.4491542,43.625252 49.4229225,39.4277518 50.3887346,35.5207686 L73.7063391,41.0342973"
        id="path-139"></path>
      <filter filterUnits="objectBoundingBox" height="121.4%" id="filter-140" width="120.6%" x="-5.5%" y="-6.1%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M40.3596669,125.816863 L16.0529891,75.2873403 C24.4591909,70.9588129 34.0258401,68.7496997 44.0473736,69.3423582 C54.0687324,69.9360072 63.2749935,73.256084 71.0529891,78.5424187 L40.3596669,125.816863"
        id="path-141"></path>
      <filter filterUnits="objectBoundingBox" height="108.8%" id="filter-142" width="108.9%" x="-2.6%" y="-2.3%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M172.228387,25.300349 L119.228387,54.6352313 C124.089064,63.7345098 131.29909,71.6918607 140.647578,77.461948 C149.99652,83.2310514 160.299087,86.0818861 170.53611,86.300349 L172.228387,25.300349"
        id="path-143"></path>
      <filter filterUnits="objectBoundingBox" height="107.6%" id="filter-144" width="109.0%" x="-2.7%" y="-2.1%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="120.558256" cy="106.99997" id="path-145" r="25.5"></circle>
      <filter filterUnits="objectBoundingBox" height="109.1%" id="filter-146" width="109.1%" x="-2.6%" y="-2.6%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M306.040068,61.4991717 L342.236816,87.2001488 C346.785141,81.2864523 349.834676,74.1857112 350.753934,66.3507554 C351.672391,58.5157995 350.344265,50.9395486 347.279941,44.2001488 L306.040068,61.4991717"
        id="path-147"></path>
      <filter filterUnits="objectBoundingBox" height="111.3%" id="filter-148" width="110.0%" x="-2.6%" y="-3.3%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="275.5" cy="98.0204437" id="path-149" r="19.5"></circle>
      <filter filterUnits="objectBoundingBox" height="111.9%" id="filter-150" width="111.9%" x="-3.4%" y="-3.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M5,16.6667829 L29.1311657,34 C32.163382,30.0116931 34.1964057,25.2228212 34.8092438,19.9387812 C35.421549,14.6547412 34.5361312,9.5451766 32.4932487,5 L5,16.6667829"
        id="path-151"></path>
      <filter filterUnits="objectBoundingBox" height="116.8%" id="filter-152" width="115.0%" x="-4.0%" y="-4.9%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.325" result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
    </defs>
    <g fill="none" fill-rule="evenodd" id="03_Strategie" stroke="none" stroke-width="1"
       transform="translate(-3.000000, 1.000000)">

      <g id="Group-5-Copy" transform="translate(1.000000, -26.000000)">
        <g id="Group">
          <g id="aktie">
            <g id="Oval">
              <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-1"></use>
            </g>
            <g id="Oval-Copy">
              <use fill="black" fill-opacity="1" filter="url(#filter-4)" xlink:href="#path-3"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-3"></use>
            </g>
            <g id="Oval-Copy-5">
              <use fill="black" fill-opacity="1" filter="url(#filter-6)" xlink:href="#path-5"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-5"></use>
            </g>
            <g id="Stroke-1-Copy"
               transform="translate(57.000000, 84.500000) scale(-1, 1) rotate(69.000000) translate(-57.000000, -84.500000) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-8)" xlink:href="#path-7"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-7"></use>
            </g>
            <g id="pie-copy-2"
               transform="translate(168.174823, 133.320241) rotate(-56.000000) translate(-168.174823, -133.320241) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-10)" xlink:href="#path-9"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-9"></use>
            </g>
            <g id="Oval-Copy-2">
              <use fill="black" fill-opacity="1" filter="url(#filter-12)" xlink:href="#path-11"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-11"></use>
            </g>
            <g id="pie-copy"
               transform="translate(104.248723, 105.512272) rotate(130.000000) translate(-104.248723, -105.512272) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-14)" xlink:href="#path-13"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-13"></use>
            </g>
            <g id="pie-copy-4"
               transform="translate(282.648738, 102.000000) rotate(145.000000) translate(-282.648738, -102.000000) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-16)" xlink:href="#path-15"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-15"></use>
            </g>
            <g id="pie-copy-3"
               transform="translate(40.465830, 85.811087) rotate(227.000000) translate(-40.465830, -85.811087) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-18)" xlink:href="#path-17"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-17"></use>
            </g>
            <g id="Oval">
              <use fill="black" fill-opacity="1" filter="url(#filter-20)" xlink:href="#path-19"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-19"></use>
            </g>
            <g id="Oval-Copy">
              <use fill="black" fill-opacity="1" filter="url(#filter-22)" xlink:href="#path-21"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-21"></use>
            </g>
            <g id="Oval-Copy-3">
              <use fill="black" fill-opacity="1" filter="url(#filter-24)" xlink:href="#path-23"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-23"></use>
            </g>
            <g id="Stroke-1-Copy"
               transform="translate(265.732243, 83.462774) scale(-1, 1) rotate(-126.000000) translate(-265.732243, -83.462774) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-26)" xlink:href="#path-25"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-25"></use>
            </g>
            <g id="Stroke-1-Copy-6"
               transform="translate(116.694951, 44.416789) scale(-1, 1) rotate(39.000000) translate(-116.694951, -44.416789) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-28)" xlink:href="#path-27"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-27"></use>
            </g>
            <g id="Stroke-1-Copy-8"
               transform="translate(345.210768, 86.693379) scale(-1, 1) rotate(39.000000) translate(-345.210768, -86.693379) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-30)" xlink:href="#path-29"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-29"></use>
            </g>
            <g id="pie-copy-2"
               transform="translate(256.500000, 165.500000) rotate(-36.000000) translate(-256.500000, -165.500000) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-32)" xlink:href="#path-31"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-31"></use>
            </g>
            <g id="pie-copy-13"
               transform="translate(341.668441, 167.557248) rotate(-36.000000) translate(-341.668441, -167.557248) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-34)" xlink:href="#path-33"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-33"></use>
            </g>
            <g id="Oval-Copy-2">
              <use fill="black" fill-opacity="1" filter="url(#filter-36)" xlink:href="#path-35"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-35"></use>
            </g>
            <g id="Oval-Copy-2">
              <use fill="black" fill-opacity="1" filter="url(#filter-38)" xlink:href="#path-37"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-37"></use>
            </g>
            <g id="Oval-Copy-9">
              <use fill="black" fill-opacity="1" filter="url(#filter-40)" xlink:href="#path-39"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-39"></use>
            </g>
            <g id="Oval-Copy-20">
              <use fill="black" fill-opacity="1" filter="url(#filter-42)" xlink:href="#path-41"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-41"></use>
            </g>
            <g id="Oval-Copy-21">
              <use fill="black" fill-opacity="1" filter="url(#filter-44)" xlink:href="#path-43"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-43"></use>
            </g>
            <g id="Oval-Copy-21">
              <use fill="black" fill-opacity="1" filter="url(#filter-46)" xlink:href="#path-45"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-45"></use>
            </g>
            <g id="Oval-Copy-10">
              <use fill="black" fill-opacity="1" filter="url(#filter-48)" xlink:href="#path-47"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-47"></use>
            </g>
            <g id="Oval-Copy-13">
              <use fill="black" fill-opacity="1" filter="url(#filter-50)" xlink:href="#path-49"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-49"></use>
            </g>
            <g id="pie-copy"
               transform="translate(223.289298, 112.942168) scale(-1, 1) rotate(-30.000000) translate(-223.289298, -112.942168) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-52)" xlink:href="#path-51"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-51"></use>
            </g>
            <g id="pie-copy-9"
               transform="translate(143.672370, 81.162172) rotate(-110.000000) translate(-143.672370, -81.162172) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-54)" xlink:href="#path-53"></use>
              <use :fill="fill" fill-rule="evenodd" stroke="#D39631" stroke-width="0.65" xlink:href="#path-53"></use>
            </g>
            <g id="pie-copy-14"
               transform="translate(362.500000, 134.221429) rotate(-90.000000) translate(-362.500000, -134.221429) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-56)" xlink:href="#path-55"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-55"></use>
            </g>
            <g id="pie-copy-8"
               transform="translate(180.913043, 91.500000) rotate(10.000000) translate(-180.913043, -91.500000) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-58)" xlink:href="#path-57"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-57"></use>
            </g>
            <g id="pie-copy-15"
               transform="translate(409.913043, 130.500000) rotate(10.000000) translate(-409.913043, -130.500000) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-60)" xlink:href="#path-59"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-59"></use>
            </g>
            <g id="pie-copy-3"
               transform="translate(169.174823, 161.709985) rotate(250.000000) translate(-169.174823, -161.709985) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-62)" xlink:href="#path-61"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-61"></use>
            </g>
          </g>
          <g id="etf-rohstoffe" transform="translate(390.000000, 26.000000)">
            <g id="Oval-Copy-7">
              <use fill="black" fill-opacity="1" filter="url(#filter-64)" xlink:href="#path-63"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-63"></use>
            </g>
            <g id="Stroke-1-Copy-5">
              <use fill="black" fill-opacity="1" filter="url(#filter-66)" xlink:href="#path-65"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-65"></use>
            </g>
            <g id="Stroke-1-Copy-9">
              <use fill="black" fill-opacity="1" filter="url(#filter-68)" xlink:href="#path-67"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-67"></use>
            </g>
            <g id="Oval-Copy-8">
              <use fill="black" fill-opacity="1" filter="url(#filter-70)" xlink:href="#path-69"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-69"></use>
            </g>
            <g id="Oval-Copy-14">
              <use fill="black" fill-opacity="1" filter="url(#filter-72)" xlink:href="#path-71"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-71"></use>
            </g>
            <g id="pie-copy-7"
               transform="translate(360.335806, 87.884485) rotate(-30.000000) translate(-360.335806, -87.884485) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-74)" xlink:href="#path-73"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-73"></use>
            </g>
            <g id="pie-copy-16"
               transform="translate(62.934147, 138.565342) rotate(-30.000000) translate(-62.934147, -138.565342) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-76)" xlink:href="#path-75"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-75"></use>
            </g>
            <g id="pie-copy-20"
               transform="translate(265.500000, 119.995865) rotate(-180.000000) translate(-265.500000, -119.995865) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-78)" xlink:href="#path-77"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-77"></use>
            </g>
            <g id="Oval-Copy-4"
               transform="translate(425.266012, 141.249970) scale(-1, 1) translate(-425.266012, -141.249970) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-80)" xlink:href="#path-79"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-79"></use>
            </g>
            <g id="Oval-Copy-17"
               transform="translate(407.250000, 141.249970) scale(-1, 1) translate(-407.250000, -141.249970) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-82)" xlink:href="#path-81"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-81"></use>
            </g>
            <g id="Oval-Copy-18"
               transform="translate(416.500000, 127.000000) scale(-1, 1) translate(-416.500000, -127.000000) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-84)" xlink:href="#path-83"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-83"></use>
            </g>
            <g id="Stroke-1-Copy-3"
               transform="translate(412.835806, 99.500000) rotate(90.000000) translate(-412.835806, -99.500000) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-86)" xlink:href="#path-85"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-85"></use>
            </g>
            <g id="Stroke-1-Copy-4"
               transform="translate(228.000000, 45.500000) rotate(90.000000) translate(-228.000000, -45.500000) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-88)" xlink:href="#path-87"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-87"></use>
            </g>
            <g id="Oval-Copy-6"
               transform="translate(425.266012, 101.634485) scale(-1, 1) translate(-425.266012, -101.634485) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-90)" xlink:href="#path-89"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-89"></use>
            </g>
            <g id="pie-copy-5"
               transform="translate(368.961518, 22.049410) rotate(18.000000) translate(-368.961518, -22.049410) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-92)" xlink:href="#path-91"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-91"></use>
            </g>
            <g id="pie-copy-22"
               transform="translate(449.421244, 117.068158) rotate(18.000000) translate(-449.421244, -117.068158) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-94)" xlink:href="#path-93"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-93"></use>
            </g>
            <g id="pie-copy-17"
               transform="translate(65.000000, 77.000000) rotate(18.000000) translate(-65.000000, -77.000000) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-96)" xlink:href="#path-95"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-95"></use>
            </g>
            <g id="pie-copy-6"
               transform="translate(444.771781, 143.500000) rotate(57.000000) translate(-444.771781, -143.500000) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-98)" xlink:href="#path-97"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-97"></use>
            </g>
            <g id="pie-copy-10"
               transform="translate(308.907428, 65.987404) scale(-1, 1) rotate(57.000000) translate(-308.907428, -65.987404) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-100)" xlink:href="#path-99"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-99"></use>
            </g>
            <g id="Oval-Copy-2">
              <use fill="black" fill-opacity="1" filter="url(#filter-102)" xlink:href="#path-101"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-101"></use>
            </g>
            <g id="Oval-Copy-19">
              <use fill="black" fill-opacity="1" filter="url(#filter-104)" xlink:href="#path-103"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-103"></use>
            </g>
            <g id="pie-copy-21"
               transform="translate(263.571622, 82.987404) rotate(57.000000) translate(-263.571622, -82.987404) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-106)" xlink:href="#path-105"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-105"></use>
            </g>
            <g id="pie-copy-19"
               transform="translate(280.626377, 145.982819) scale(-1, 1) rotate(57.000000) translate(-280.626377, -145.982819) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-108)" xlink:href="#path-107"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-107"></use>
            </g>
            <g id="pie-copy-18"
               transform="translate(23.571622, 143.987404) scale(-1, 1) rotate(57.000000) translate(-23.571622, -143.987404) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-110)" xlink:href="#path-109"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-109"></use>
            </g>
            <g id="pie-copy-4"
               transform="translate(401.005937, 73.800349) rotate(-69.000000) translate(-401.005937, -73.800349) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-112)" xlink:href="#path-111"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-111"></use>
            </g>
            <g id="Oval">
              <use fill="black" fill-opacity="1" filter="url(#filter-114)" xlink:href="#path-113"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-113"></use>
            </g>
          </g>
          <g id="etf-anleihe"
             transform="translate(562.000000, 111.000000) scale(-1, 1) translate(-562.000000, -111.000000) translate(461.000000, 44.000000)">
            <g id="Oval-Copy-7">
              <use fill="black" fill-opacity="1" filter="url(#filter-116)" xlink:href="#path-115"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-115"></use>
            </g>
            <g id="Stroke-1-Copy-5">
              <use fill="black" fill-opacity="1" filter="url(#filter-118)" xlink:href="#path-117"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-117"></use>
            </g>
            <g id="Stroke-1-Copy-7"
               transform="translate(45.000000, 72.500000) rotate(-143.000000) translate(-45.000000, -72.500000) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-120)" xlink:href="#path-119"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-119"></use>
            </g>
            <g id="Oval-Copy-8">
              <use fill="black" fill-opacity="1" filter="url(#filter-122)" xlink:href="#path-121"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-121"></use>
            </g>
            <g id="pie-copy-7"
               transform="translate(105.058256, 69.884485) rotate(-30.000000) translate(-105.058256, -69.884485) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-124)" xlink:href="#path-123"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-123"></use>
            </g>
            <g id="Oval-Copy-4"
               transform="translate(192.000000, 122.499970) scale(-1, 1) translate(-192.000000, -122.499970) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-126)" xlink:href="#path-125"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-125"></use>
            </g>
            <g id="Oval-Copy-15"
               transform="translate(13.000000, 122.499970) scale(-1, 1) translate(-13.000000, -122.499970) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-128)" xlink:href="#path-127"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-127"></use>
            </g>
            <g id="Oval-Copy-16"
               transform="translate(60.000000, 77.000000) scale(-1, 1) translate(-60.000000, -77.000000) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-130)" xlink:href="#path-129"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-129"></use>
            </g>
            <g id="Oval-Copy-12"
               transform="translate(169.000000, 119.499970) scale(-1, 1) translate(-169.000000, -119.499970) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-132)" xlink:href="#path-131"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-131"></use>
            </g>
            <g id="Stroke-1-Copy-3"
               transform="translate(157.558256, 81.500000) rotate(90.000000) translate(-157.558256, -81.500000) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-134)" xlink:href="#path-133"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-133"></use>
            </g>
            <g id="Oval-Copy-6"
               transform="translate(169.988462, 83.634485) scale(-1, 1) translate(-169.988462, -83.634485) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-136)" xlink:href="#path-135"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-135"></use>
            </g>
            <g id="Oval-Copy-11"
               transform="translate(84.500000, 84.000000) scale(-1, 1) translate(-84.500000, -84.000000) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-138)" xlink:href="#path-137"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-137"></use>
            </g>
            <g id="pie-copy-12"
               transform="translate(61.706339, 46.854102) rotate(58.000000) translate(-61.706339, -46.854102) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-140)" xlink:href="#path-139"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-139"></use>
            </g>
            <g id="pie-copy-11"
               transform="translate(43.552989, 97.532187) rotate(247.000000) translate(-43.552989, -97.532187) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-142)" xlink:href="#path-141"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-141"></use>
            </g>
            <g id="pie-copy-4"
               transform="translate(145.728387, 55.800349) rotate(-69.000000) translate(-145.728387, -55.800349) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-144)" xlink:href="#path-143"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-143"></use>
            </g>
            <g id="Oval">
              <use fill="black" fill-opacity="1" filter="url(#filter-146)" xlink:href="#path-145"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-145"></use>
            </g>
          </g>
          <g id="etf-aktie"
             transform="translate(478.000000, 118.000000) scale(-1, 1) translate(-478.000000, -118.000000) translate(299.000000, 59.000000)">
            <g id="pie-copy-2"
               transform="translate(328.540068, 65.700149) rotate(-65.000000) translate(-328.540068, -65.700149) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-148)" xlink:href="#path-147"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-147"></use>
            </g>
            <g id="Oval-Copy-3">
              <use fill="black" fill-opacity="1" filter="url(#filter-150)" xlink:href="#path-149"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-149"></use>
            </g>
            <g id="pie-copy-3"
               transform="translate(20.000000, 19.500000) scale(-1, 1) rotate(200.000000) translate(-20.000000, -19.500000) ">
              <use fill="black" fill-opacity="1" filter="url(#filter-152)" xlink:href="#path-151"></use>
              <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.65" xlink:href="#path-151"></use>
            </g>
          </g>
        </g>
      </g>

    </g>
    <polyline data-v-863cc8e6=""
              fill-rule="nonzero"
              id="Line-Left"
              points="0,110 0,178" transform="translate(-2.000000, 0.000000)"
              stroke="#02073A" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
    </polyline>
    <polyline data-v-863cc8e6=""
              fill-rule="nonzero"
              id="Line-Right"
              :points="(width - 4) + ',110 ' + (width - 4) + ',178'" transform="translate(-1.000000, 0.000000)"
              stroke="#02073A" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
    </polyline>
  </svg>
</template>

<script>
export default {
  name: 'finShapesCollection',
  data () {
    return {
        width: this.fullWidth,
        height: 156 * this.width / this.fullWidth
    }
  },
  props: {
    /** the color the shapes collection is getting filled with */
    fill: {
      type: String,
      default () {
        return this.$finColors.accentYellow
      }
    },
      /** the color of the borders of the shapes */
      stroke: {
          type: String,
          default() {
              return this.$finColors.accentYellow
          }
      },
    percentage: {
      type: Number,
      default: 50
    },
    fullWidth: {
      type: Number,
      default: 857 /* original svg width */
    },
    offset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    calcSvgWidth () {
      const percentageWidth = this.fullWidth / 100 * this.percentage
      let offsetWidth = this.fullWidth / 100 * this.offset

      offsetWidth = percentageWidth + this.fullWidth / 100 * this.offset

      this.width = (this.offset === 0) ? percentageWidth : offsetWidth
      this.height = 156 * this.width / this.fullWidth
    }
  },
  watch: {
    percentage () {
      this.calcSvgWidth()
    },
    offset () {
      this.calcSvgWidth()
    }
  },
  mounted () {
    this.$nextTick(() => this.calcSvgWidth())
  }
}
</script>

<style scoped>

</style>
